import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Parallax } from 'react-parallax';

import FullLogo from './icons/fullLogo';
import './welcome.css';
import ChevronIcon from './icons/chevron';

export function Welcome(): React.ReactElement {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "statue2.jpg" }) {
        childImageSharp {
          # Specify a fixed image and fragment.
          # The default width is 400 pixels
          fixed(width: 1500) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);
  return (
    <div className="welcome-background">
      <Parallax
        bgImage={data.file.childImageSharp.fixed}
        bgImageSrcSet={data.file.childImageSharp.fixed.srcSet}
        strength={300}
      >
        <div id="welcome" className="welcome">
          <div className="welcome-logo-wrapper">
            <div className="welcome-logo">
              <FullLogo />
            </div>
            <a
              role="button"
              onClick={() =>
                window.scrollTo(
                  0,
                  document.getElementById('about')!.getBoundingClientRect().top +
                    document.documentElement.scrollTop -
                    50,
                )
              }
              className="welcome-arrow"
            >
              <ChevronIcon />
            </a>
          </div>
        </div>
      </Parallax>
    </div>
  );
}
